import React from "react";
import { Button } from "@mui/material";
import { ChevronRight } from "@mui/icons-material";

export const MeineAmazonSendung: React.FC = () => {
  return (
    <div>
      <p>
        Alle Fragen zum Versand von Briefen und Päckchen von Momox, Medimops
        oder Amazon finden Sie unseren FAQs. <br></br>
        <Button
          size='small'
          style={{ textTransform: 'none' }}
          variant='contained'
          endIcon={<ChevronRight />}
          href='https://www.pin-ag.de/faq/amazon-sendungen'
          target='_blank'
          className='my-3'
        >
          Weitere FAQs
        </Button>
      </p>
    </div>
  );
};
